<template>
    <div v-if="show">
        <div v-if="type === 'space'" data-test-class="side-menu-space">
            <br />
        </div>
        <div
            v-else
            :class="['sidebar-menu', { 'sidebar-menu-active': active }]"
            tabindex="0"
            data-test-class="side-menu-element"
            @click="
                () => {
                    if (!active) {
                        handler();
                        scrollToTop();
                    }
                }
            "
            @keyup.enter="
                () => {
                    if (!active) {
                        handler();
                        scrollToTop();
                    }
                }
            "
        >
            <i v-if="icon" :class="['fal', icon]" class="side-menu-icon" />
            <a
                :href="`#${path}`"
                class="side-menu-label"
                :data-test-id="path.replace('/', 'menu-').replace(/\//g, '-')"
                @click="e => e.preventDefault()"
            >
                <span :class="{ 'tw-font-bold': type === 'parent' }">{{ label }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        handler: {
            type: Function,
            required: true,
        },
        icon: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        path: {
            type: String,
            default: "",
        },
        show: Boolean,
        active: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "",
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
    methods: {
        scrollToTop() {
            // FIXME - Not supported in IE11 and Safari
            // (cf: https://caniuse.com/#feat=css-scroll-behavior)
            //
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
};
</script>

<style scoped>
.sidebar-menu {
    cursor: pointer;
}

.side-menu-icon {
    width: 16px;
    text-align: center;
    transition: opacitiy 200ms ease-in-out;
    margin-right: 15px;
}
.side-menu-label {
    color: #252c3a;
    text-decoration: none;
}
</style>
